import { Link } from "react-router-dom";
import { Card, CardContent, Button } from "@/components/primitives";
import { Calendar, Plus } from "lucide-react";

interface EmptyStateProps {
	hasFilters: boolean;
}

export const EmptyState = ({ hasFilters }: EmptyStateProps) => {
	return (
		<Card className="border-2 shadow-xl bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm">
			<CardContent className="text-center py-12">
				<div className="p-3 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
					<Calendar className="h-8 w-8 text-white" />
				</div>
				<h3 className="text-xl font-semibold text-foreground mb-2">
					{hasFilters ? "No reflections found" : "No reflections yet"}
				</h3>
				<p className="text-muted-foreground mb-6 max-w-md mx-auto">
					{hasFilters
						? "Try adjusting your search or filters to find what you're looking for."
						: "Start your journey by creating your first reflection"}
				</p>
				<Link to="/reflection/new">
					<Button className="bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white shadow-md hover:shadow-lg transition-all">
						<Plus className="h-4 w-4 mr-2" />
						{hasFilters
							? "Create New Reflection"
							: "Create Your First Reflection"}
					</Button>
				</Link>
			</CardContent>
		</Card>
	);
};
